import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { Avatar, Skeleton } from 'antd';
import { DefaultText, SupportText } from '../../typography';
import { styled } from '@xstyled/styled-components';
import Meta from 'antd/lib/card/Meta';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledMeta = styled(Meta)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  .ant-card-meta-avatar {\n    padding-right: 8px;\n  }\n  .ant-card-meta-detail > div:not(:last-child) {\n    margin-bottom: 0px;\n  }\n"])));
var StyledAvatar = styled(Avatar)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", " !important;\n"])), function (props) {
  return props.theme.colors.gold1;
});
var StyledTitleCard = styled(DefaultText)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 600;\n"])));
export var UserAvatar = function UserAvatar(_ref) {
  var isLoadingUserInfo = _ref.isLoadingUserInfo,
      urlNavigateAccountSettingPage = _ref.urlNavigateAccountSettingPage,
      firstLetterOfUsername = _ref.firstLetterOfUsername,
      formattedUsername = _ref.formattedUsername;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isLoadingUserInfo ? /*#__PURE__*/_jsx(Skeleton, {
      active: true,
      avatar: {
        size: 'large'
      },
      paragraph: {
        rows: 0
      }
    }) : /*#__PURE__*/_jsx(StyledMeta, {
      avatar: /*#__PURE__*/_jsx("a", {
        href: urlNavigateAccountSettingPage,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/_jsx(StyledAvatar, {
          size: "large",
          children: /*#__PURE__*/_jsx("strong", {
            children: firstLetterOfUsername
          })
        })
      }),
      title: /*#__PURE__*/_jsx("a", {
        href: urlNavigateAccountSettingPage,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/_jsx(StyledTitleCard, {
          children: formattedUsername
        })
      }),
      description: /*#__PURE__*/_jsx(SupportText, {
        children: "Standard"
      })
    })
  });
};